import { createLens } from '@dhmk/zustand-lens';
import type { StateCreator } from 'zustand';
import type { GraphValidation, GraphId } from '../types/graph';
import type { GraphState } from '.';
import type { StoreSlice } from '@/store';

export interface ValidationSlice {
  validation: GraphValidation | null;
  setValidation: (validation: GraphValidation | null) => void;
}

export const createValidationSlice =
  (
    global: StoreSlice,
    graphId: GraphId
  ): StateCreator<
    GraphState,
    [['zustand/immer', never]],
    [],
    ValidationSlice
  > =>
  (_set, _get) => {
    const [set] = createLens(_set, _get, ['valid']);
    const validationApi = global.graphs.validation(graphId);

    return {
      validation: validationApi.get(),
      setValidation: (validation) => {
        set((s) => {
          s.validation = validation;
        });
        if (validation) {
          validationApi.set(validation);
        }
      },
    };
  };
